<template>
    <div class="auth-wrapper auth-v2">
        <b-row class="auth-inner m-0">


            <!-- Register-->
            <b-col lg="4" class="d-flex  auth-bg px-0 p-lg-5">
                <b-col sm="8" md="6" lg="12" class="px-xl-1 mx-auto">
                    <h2 class=" mt-5">Regístrese</h2>
                    <!-- form -->
                    <div class="userPasswordAlert justify-content-center align-items-center ml-0">
                        <p class="userId pt-1 ml-1">Usuario</p>
                        <small class="statement ml-1">Su nuevo usuario corresponde a su cédula</small>
                    </div>
                    <validation-observer ref="registerForm" #default="{ invalid }">
                        <b-form class="auth-register-form mt-2" @submit.prevent="register">
                            <!-- username -->
                            <b-form-group label="Usuario" label-for="register-userID">
                                <validation-provider #default="{ errors }" name="userID" vid="userID"
                                    rules="required">
                                    <b-form-input id="register-userID" v-model="userID" name="register-userID"
                                        :state="errors.length > 0 ? false : null" placeholder="" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>



                            <!-- password -->
                            <b-form-group label-for="register-password" label="Contraseña">
                                <validation-provider #default="{ errors }" name="Contraseña" vid="password"
                                    rules="required">
                                    <b-input-group class="input-group-merge"
                                        :class="errors.length > 0 ? 'is-invalid' : null">
                                        <b-form-input id="register-password" v-model="password"
                                            class="form-control-merge" :type="passwordFieldType"
                                            :state="errors.length > 0 ? false : null" name="register-password"
                                            placeholder="············" />
                                        <b-input-group-append is-text>
                                            <feather-icon :icon="passwordToggleIcon" class="cursor-pointer"
                                                @click="togglePasswordVisibility" />
                                        </b-input-group-append>
                                    </b-input-group>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        <!-- passwordConfirm -->

                         <b-form-group label-for="register-passwordConfirm" label="Repetir Contraseña">
                                <validation-provider #default="{ errors }" name="Repetir Contraseña" vid="passwordConfirm"
                                    rules="required">
                                    <b-input-group class="input-group-merge"
                                        :class="errors.length > 0 ? 'is-invalid' : null">
                                        <b-form-input id="register-passwordConfirm" v-model="password"
                                            class="form-control-merge" :type="passwordFieldType"
                                            :state="errors.length > 0 ? false : null" name="register-passwordComfirm"
                                            placeholder="············" />
                                        <b-input-group-append is-text>
                                            <feather-icon :icon="passwordToggleIcon" class="cursor-pointer"
                                                @click="togglePasswordVisibility" />
                                        </b-input-group-append>
                                    </b-input-group>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                            <div class="d-flex justify-content-center align-items-center mt-5 ">
                                <b-button class=" bg-primary" type="submit" :disabled="invalid">
                                    Guardar
                                </b-button>
                            </div>
                        </b-form>
                    </validation-observer>


                </b-col>
            </b-col>
            <!-- /Register-->
        </b-row>
    </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
    BRow, BCol, BLink, BButton, BForm, BFormCheckbox, BFormGroup, BFormInput, BInputGroup, BInputGroupAppend, BImg, BCardTitle, BCardText,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import useJwt from '@/auth/jwt/useJwt'


export default {
    components: {

        BRow,
        BImg,
        BCol,
        BLink,
        BButton,
        BForm,
        BCardText,
        BCardTitle,
        BFormCheckbox,
        BFormGroup,
        BFormInput,
        BInputGroup,
        BInputGroupAppend,
        // validations
        ValidationProvider,
        ValidationObserver,
    },
    mixins: [togglePasswordVisibility],
    data() {
        return {
            status: '',
            userID:'',
            password:'',
            repassword:'',
            sideImg: require('@/assets/images/pages/register-v2.svg'),
            // validation
            required,
            email,
        }
    },
    computed: {
        passwordConfirm() {
            return this.password == this.repassword ? this.password : ''
        },
        passwordToggleIcon() {
            return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
        },
        imgUrl() {
            if (store.state.appConfig.layout.skin === 'dark') {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.sideImg = require('@/assets/images/pages/register-v2-dark.svg')
                return this.sideImg
            }
            return this.sideImg
        },
    },
    methods: {
        register() {
            this.$refs.registerForm.validate().then(success => {
                if (success) {
                    console.log("success")
                    useJwt.register({
                        names: this.$route.params.firstName + this.$route.params.lastName,
                        phone: this.$route.telephone,
                        email: this.$route.params.email,
                        position: this.$route.position,
                        profike_image:'',
                        age:0,
                        birthdate:this.$route.params.birthday,
                        level:0,
                        password: this.password,        
                     //   userID: this.userID,

                    })
                        .then(response => {
                            console.log(response)
                            useJwt.setToken(response.data.JWT)
                         //   useJwt.setRefreshToken(response.data.refreshToken)
                           // localStorage.setItem('userData', JSON.stringify(response.data))
                           // this.$ability.update(response.data.userData.ability)
                            this.$router.push('/')
                        })
                        .catch(error => {
                            this.$refs.registerForm.setErrors(error.response.data.error)
                        })
                }
            })
        },
    },

    created() {
       console.log(this.$route.params.birthday);

    }
}
/* eslint-disable global-require */
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
